import api from 'api'
import { z } from 'zod'

export const deleteCompanyInviteParamsSchema = z.object({
  companyId: z.number(),
  inviteId: z.number(),
})

export type DeleteCompanyInviteParams = z.infer<
  typeof deleteCompanyInviteParamsSchema
>

export const deleteCompanyInvite = async ({
  companyId,
  inviteId,
}: DeleteCompanyInviteParams): Promise<void> => {
  await api.delete(`/admin/company/invite/${companyId}/${inviteId}`)
}
